import { assets } from "../assets/assets";
import { getAmazonBroadcastUrl, getTwitchStreamUrl } from "./Streams";

const normalizeValue = (value = "") => String(value || "").trim();
const amazonLiveLogo = `${process.env.PUBLIC_URL || ''}/assets/icons/amazon_live.png`;

export const isAmazonStreamChannel = (channel) => {
    if (!channel || typeof channel !== "object") {
        return false;
    }

    return Boolean(channel.isAmazon || normalizeValue(channel.amazonBroadcastId));
};

export const getAmazonChannelKey = (broadcastId = "") => `amazon-${normalizeValue(broadcastId).toLowerCase()}`;

export const getStreamChannelId = (channel) => {
    if (!channel) {
        return "";
    }

    if (typeof channel === "string") {
        return normalizeValue(channel).toLowerCase();
    }

    if (isAmazonStreamChannel(channel)) {
        if (normalizeValue(channel.amazonBroadcastId)) {
            return getAmazonChannelKey(channel.amazonBroadcastId);
        }

        return normalizeValue(channel.twitchHandle).toLowerCase();
    }

    return normalizeValue(channel.twitchHandle).toLowerCase();
};

export const getStreamChannelLabel = (channel) => {
    if (!channel) {
        return "";
    }

    if (typeof channel === "string") {
        return channel.startsWith("amazon-")
            ? `Amazon Live - ${channel.slice(7)}`
            : channel;
    }

    if (isAmazonStreamChannel(channel)) {
        return `Amazon Live - ${normalizeValue(channel.amazonBroadcastId)}`;
    }

    return normalizeValue(channel.twitchHandle);
};

export const getStreamChannelProfilePic = (channel) => {
    if (typeof channel === "string") {
        return channel.startsWith("amazon-")
            ? amazonLiveLogo
            : assets.BlankUser;
    }

    if (isAmazonStreamChannel(channel)) {
        return amazonLiveLogo;
    }

    return channel?.profilePic || assets.BlankUser;
};

export const getStreamChannelUrl = (channel) => {
    if (!channel) {
        return "";
    }

    if (typeof channel === "string") {
        return channel.startsWith("amazon-")
            ? getAmazonBroadcastUrl(channel.slice(7))
            : getTwitchStreamUrl(channel);
    }

    return isAmazonStreamChannel(channel)
        ? getAmazonBroadcastUrl(channel.amazonBroadcastId)
        : getTwitchStreamUrl(channel.twitchHandle);
};

export const buildTwitchStreamChannel = (twitchHandle, profilePic = "") => ({
    twitchHandle: normalizeValue(twitchHandle),
    profilePic: profilePic || "",
    amazonBroadcastId: "",
    isAmazon: false,
});

export const buildAmazonStreamChannel = (broadcastId) => ({
    twitchHandle: getAmazonChannelKey(broadcastId),
    profilePic: "",
    amazonBroadcastId: normalizeValue(broadcastId),
    isAmazon: true,
});